import script from "./type_police.vue?vue&type=script&setup=true&lang=js"
export * from "./type_police.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__